import DownloadIcon from '@mui/icons-material/Download';
import { ChartAction } from './useChartActions';
import { useExportGrapeDiameterDistributionChart } from './useExportGrapeDiameterDistributionChart';

export const useGrapeDiameterDistributionChartActions =
  (): ChartAction<GrapeDiameterDistributionChartAction>[] => {
    const { exportCSV } = useExportGrapeDiameterDistributionChart();

    const actions: ChartAction<GrapeDiameterDistributionChartAction>[] = [
      {
        actionId: 'EXPORT',
        onClick: exportCSV,
        Icon: DownloadIcon,
      },
    ];
    return actions;
  };

export type GrapeDiameterDistributionChartAction = 'EXPORT';
